import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { DevisCTA } from "@/components/DevisCTA";
import { Wrench, ArrowRight, Info } from "lucide-react";

const travaux = [
  "Petites réparations extérieures", "Fixation et pose d'éléments simples",
  "Réglages et ajustements courants", "Petits travaux d'entretien",
  "Remise en état de petits éléments extérieurs", "Interventions diverses selon le besoin",
];

export default function Reparations() {
  return (
    <div data-testid="reparations-page">
      <Seo title="Petites réparations & petits travaux | Sandro Services 06 (06)" description="Petits travaux et réparations courantes pour l'entretien de vos extérieurs dans les Alpes-Maritimes, selon la nature de l'intervention." />
      <PageHero chapter="Petites réparations" title="Petites réparations & petits travaux" subtitle="Sandro Services 06 réalise des interventions de petite ampleur selon la nature des travaux." />

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20 grid lg:grid-cols-2 gap-14">
        <Reveal>
          <Stagger className="grid gap-4" stagger={0.07}>
            {travaux.map((t) => (
              <StaggerItem key={t} className="flex items-center gap-4 bg-white border border-line rounded-2xl px-6 py-5 hover:shadow-soft transition-all">
                <span className="w-10 h-10 rounded-full bg-sand-100 grid place-items-center text-olive shrink-0"><Wrench size={18} /></span>
                <span className="text-ink font-medium">{t}</span>
              </StaggerItem>
            ))}
          </Stagger>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="bg-forest text-sand rounded-2xl p-8 md:p-10 grain relative">
            <Info className="text-olive" />
            <h3 className="mt-5 font-display text-3xl leading-tight">Une intervention adaptée à votre besoin</h3>
            <p className="mt-4 text-sand/80 leading-relaxed">
              Petits travaux et réparations courantes selon la nature de l'intervention. Chaque demande
              est étudiée afin de proposer une solution adaptée et réalisable.
            </p>
            <p className="mt-4 text-sand/60 text-sm leading-relaxed">
              Certaines interventions nécessitant une qualification professionnelle particulière ne
              peuvent pas être réalisées.
            </p>
            <Link to="/contact" data-testid="reparations-decrire-btn" className="mt-8 inline-flex items-center gap-2 bg-olive text-white rounded-full px-7 py-4 font-semibold hover:bg-olive-hover transition-all hover:-translate-y-1">
              Décrire mon besoin <ArrowRight size={18} />
            </Link>
          </div>
        </Reveal>
      </section>

      <DevisCTA title="Un petit chantier en tête ?" text="Décrivez-nous votre projet, nous étudions sa faisabilité." />
    </div>
  );
}
